export default __webpack_public_path__ + "static/media/box-halloween.d04a3dc3.svg";